/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CreateLocationResponse } from './CreateLocationResponse';
import {
    CreateLocationResponseFromJSON,
    CreateLocationResponseFromJSONTyped,
    CreateLocationResponseToJSON,
    CreateLocationResponseToJSONTyped,
} from './CreateLocationResponse';

/**
 * 
 * @export
 * @interface ResultOfCreateLocationResponse
 */
export interface ResultOfCreateLocationResponse {
    /**
     * 
     * @type {CreateLocationResponse}
     * @memberof ResultOfCreateLocationResponse
     */
    data: CreateLocationResponse | null;
    /**
     * 
     * @type {boolean}
     * @memberof ResultOfCreateLocationResponse
     */
    isSuccess: boolean;
    /**
     * 
     * @type {Error}
     * @memberof ResultOfCreateLocationResponse
     */
    error: Error | null;
}

/**
 * Check if a given object implements the ResultOfCreateLocationResponse interface.
 */
export function instanceOfResultOfCreateLocationResponse(value: object): value is ResultOfCreateLocationResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('isSuccess' in value) || value['isSuccess'] === undefined) return false;
    if (!('error' in value) || value['error'] === undefined) return false;
    return true;
}

export function ResultOfCreateLocationResponseFromJSON(json: any): ResultOfCreateLocationResponse {
    return ResultOfCreateLocationResponseFromJSONTyped(json, false);
}

export function ResultOfCreateLocationResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResultOfCreateLocationResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': CreateLocationResponseFromJSON(json['data']),
        'isSuccess': json['isSuccess'],
        'error': json['error'],
    };
}

export function ResultOfCreateLocationResponseToJSON(json: any): ResultOfCreateLocationResponse {
    return ResultOfCreateLocationResponseToJSONTyped(json, false);
}

export function ResultOfCreateLocationResponseToJSONTyped(value?: ResultOfCreateLocationResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': CreateLocationResponseToJSON(value['data']),
        'isSuccess': value['isSuccess'],
        'error': value['error'],
    };
}

